import React from 'react';

import { type IPaymentCardsOnboardingDialogContext } from './types';

// context used to store onboarding navigation data used by the useSignupDialogNavigation hook
export const PaymentCardsOnboardingDialogContext = React.createContext<IPaymentCardsOnboardingDialogContext | null>(null);
